"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const logo_1 = require("../logo");
const page_header_styled_1 = require("./page-header.styled");
const PageHeaderLink = ({ links, current }) => {
    const titles = Object.keys(links);
    const [open, setOpen] = React.useState(false);
    return React.createElement("ul", { className: "page-header__list" }, titles.map((title) => {
        const url = links[title];
        const classNames = ['page-header__link'];
        if (url === current)
            classNames.push('page-header__link--current');
        if (typeof url === 'string') {
            return React.createElement("li", { className: "page-header__list-item" }, url.startsWith('http') ?
                React.createElement("a", { className: classNames.join(' '), href: url, target: "_blank" }, title)
                :
                    React.createElement(react_router_dom_1.Link, { className: classNames.join(' '), to: url }, title));
        }
        React.useEffect(() => {
            const closeMenu = () => setOpen(false);
            document.addEventListener('click', closeMenu);
            return () => document.removeEventListener('click', closeMenu);
        });
        classNames.push('page-header__link--parent', `page-header__link--${open ? 'open' : 'shut'}`);
        return React.createElement("li", { className: "page-header__list-item" },
            React.createElement("a", { className: classNames.join(' '), onClick: (e) => { e.nativeEvent.stopImmediatePropagation(); e.stopPropagation(); setOpen(!open); } }, title),
            React.createElement(PageHeaderLink, { links: url, current: current }));
    }));
};
exports.PageHeader = (props) => {
    const { sublinks, current, mode } = props;
    const [open, setOpen] = React.useState(false);
    return React.createElement(page_header_styled_1.default, null,
        React.createElement("header", { className: `page-header page-header--${mode || 'full'}` },
            React.createElement("div", { className: "page-header__container" },
                React.createElement("div", { className: "page-header__upper" },
                    React.createElement("div", { className: "page-header__logo" },
                        React.createElement(logo_1.default, null)),
                    React.createElement("a", { className: `page-header__toggle page-header__toggle--${open ? 'open' : 'shut'}`, onClick: () => setOpen(!open) }, "Menu")),
                React.createElement("nav", { className: `page-header__navigation page-header__navigation--${open ? 'visible' : 'hidden'}` },
                    React.createElement("div", { className: "page-header__links" },
                        React.createElement(PageHeaderLink, Object.assign({}, props))),
                    sublinks && React.createElement("div", { className: "page-header__sublinks" },
                        React.createElement(PageHeaderLink, { links: sublinks, current: current }))))));
};
//# sourceMappingURL=PageHeader.js.map